import Vue from 'vue';
import Vuex from 'vuex';

import projects from '@/projects';

Vue.use(Vuex);

const categories = Object.keys(projects)
  .reduce((p, curr) => {
    return p.concat(projects[curr].categories);
  }, [])
  .filter((v, i, a) => a.indexOf(v) === i);

const state = {
  categories,
  projects,
  featured: Object.keys(projects).find(id => projects[id].name === 'Love Me, Fear Me')
};

function prioritySort (pA, pB) {
  const priA = pA.priority || 0;
  const priB = pB.priority || 0;

  return priA - priB;
}

function categoryFilter (category) {
  return function (project) {
    return category
      ? project.categories.find(c => c.name.match(category))
      : true;
  };
}

function projectNameFilter (projectName) {
  return function (project) {
    return projectName && project.name.match(projectName);
  };
}

function getProjects (state) {
  return Object.keys(state.projects)
    .map(p => state.projects[p]);
}

export default new Vuex.Store({
  state,
  getters: {
    email: () => 'veronica@bendpanic.com',
    categories: state => state.categories
      .sort((a, b) => a.id - b.id),
    projects: state => getProjects(state)
      .filter(categoryFilter(state.route.params.category))
      .sort(prioritySort),
    selectedProject: state => getProjects(state)
      .filter(projectNameFilter(state.route.params.project))[0],
    featured: state => state.featured && state.projects[state.featured]
  },
  mutations: {
  },
  actions: {
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js